import React, { useEffect } from 'react';
import { Landing } from './pages/Landing';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3k8jidhsmb2o4">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3k92qy7wdoeph" />
      </noscript>
      <Landing data-id="element-2" data-mp="2riko97zkgfcl" />
    </>;
}